import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardBank = (props) => /* @__PURE__ */ _jsx("svg", {
	className: "p-Icon p-Icon--bank Icon p-Icon--md p-TabIcon TabIcon p-TabIcon--selected TabIcon--selected",
	role: "presentation",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M5 7.5V14h1.5V7.5h3V14H11V7.5h3V14h1a1 1 0 0 1 1 1v1H0v-1a1 1 0 0 1 1-1h1V7.5h3zM8 0c4.681 2.572 7.181 3.95 7.5 4.134A1 1 0 0 1 14.98 6H1.02A1 1 0 0 1 .5 4.134C.82 3.95 3.32 2.572 8 0z",
		clipRule: "evenodd"
	})
});
export default SvgCardBank;
